export const dictionary = {
	de: {
		required: 'Pflichtfeld',
	},
	en: {
		required: 'required',
	},
};
